import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <main className="flex flex-col items-center justify-center min-h-[70vh] px-4 text-center">
      <h1 className="text-8xl font-extrabold text-mainRed mb-4">404</h1>
      <h2 className="text-2xl md:text-3xl font-semibold mb-2">Page Not Found</h2>
      <p className="text-gray-600 mb-8">
        The page you’re looking for doesn’t exist or was moved.
      </p>
      <Link
        to="/"
        className="btn uppercase border-2 border-mainRed text-mainRed hover:bg-mainRed hover:text-white px-6 py-2 rounded-md transition-all duration-200"
      >
        Back to Home
      </Link>
    </main>
  );
}
